import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { handleFileUpload } from '../../../Utilities'


const FileUploader = () => {
  const fileInputRef = useRef(null);

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />
      <Button
        variant="success"
        size="md"
        onClick={triggerFileInput}
      >
        Upload Data
      </Button>
    </div>
  );
};

export default FileUploader;
